<ng-container *ngIf="!isCollapsed">
  <div class="sidebar-image">
    <div>
      <div class="logo__image">
        <img  src="/public/images/logo-02.svg" height="80" width="auto"> 
        <span class="logo__label">Horizon</span>
      </div>
   
    </div>
    <!-- <div class="logo__administratori-section">
      <div class="logo__admininstratori-operativ-label">{{ getTranslation('Layout.Sider.OperationalAdmin') }}</div>
      <div class="logo__admininstratori-operativ-label">{{ getTranslation('Layout.Sider.Admin') }}</div>
    </div> -->
  </div>
  <nz-divider class="horizon-divider"></nz-divider>
  <ul 
   nz-menu 
   nzMode="inline" 
   nzTheme="dark" 
   style="padding-bottom: 50px;" 
   [nzInlineCollapsed]="isCollapsed">
  <ng-container *ngFor="let nav of navigationList; let i = index">
    
      <div style="display:flex">
        <div class="tt" *ngIf="this.currentRoute != '' && this.currentRoute.startsWith(nav.url)"></div>
        <li 
        nz-menu-item 
        (click)="onNavigation(nav.navigation)"
        [nzSelected]="this.currentRoute != '' && this.currentRoute.includes(nav.url)"
        [title]=""
        *ngIf="!(nav.label.startsWith('facebook')) && 
               !(nav.label.startsWith('instagram')) &&
               !(nav.label.startsWith('tiktok')) &&
               !(nav.label.startsWith('twitter')) &&
               !(nav.label.startsWith('reddit')) &&
               !(nav.label.startsWith('youtube'))" style="font-size: medium;">
        <fa-icon [icon]="getIcon(nav.icon)" size="2x" [ngStyle]="{'margin-right': '10px'}"></fa-icon>
        <span>{{nav.label}}</span>
      </li>
    
    </div>
   
     <!-- <li
       class="dropdown-icon"
       nz-submenu
       nzMode="inline"
       style="padding-bottom: 7px; padding-top: 5px;"
       *ngIf="nav.labelTranslationId === 'Layout.Sider.Configure' && !userContext.isInspektorRAS()">
       >
        <span style="margin-left: -20px;" title="{{ getTranslation(nav.labelTranslationId) }}">
          <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
          <span style="color: #9fa3aa;">{{ getTranslation('Layout.Sider.Configurations') }}</span>
        </span>
        <ul >
          <li 
            nz-menu-item 
            (click)="onNavigation('configure-algorithm')"
            style="padding-left: 30px !important;"
          >
          <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
            <span>{{ getTranslation('Layout.Sider.ConfigureAlg') }}</span>
          </li>
          <li 
            nz-menu-item 
            (click)="onNavigation('configure-training')"
            style="padding-left: 30px !important;" 
          >
         <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
           <span>{{ getTranslation('Layout.Sider.Configure') }}</span>
          </li>
       </ul>
      </li> -->
  </ng-container>
</ul>
</ng-container>


<ng-container *ngIf="isCollapsed">
  <div class="sidebar-image">
    <div>
      <div class="logo__image">
        <img src="/public/images/logo-02.svg" height="100" width="50">
      </div>
    </div>
  </div>
  <nz-divider class="horizon-divider"></nz-divider>
  <ul nz-menu nzMode="inline" nzTheme="dark" style="padding-bottom: 40px;" [nzInlineCollapsed]="isCollapsed">
    <ng-container *ngFor="let nav of navigationList; let i = index">
      <div style="display:flex">
        <div class="tt" *ngIf="this.currentRoute != '' && this.currentRoute.startsWith(nav.url)"></div>
        <li 
        nz-menu-item
        nz-tooltip
        (click)="onNavigation(nav.navigation)" 
        [nzSelected]="this.currentRoute != '' && this.currentRoute.startsWith(nav.url)"
        nzTooltipPlacement="right" 
        [nzTooltipTitle]="nav.label" 
        class="ant-menu-item-collapsed"
        *ngIf="!(nav.label.startsWith('facebook')) && 
               !(nav.label.startsWith('instagram')) &&
               !(nav.label.startsWith('tiktok')) &&
               !(nav.label.startsWith('twitter')) &&
               !(nav.label.startsWith('reddit')) &&
               !(nav.label.startsWith('youtube'))">

        <!--<img [src]="nav.iconUrl" height="40" width="40" class="ra
        s-menu-item__collapsed-image">   -->
        <fa-icon [icon]="getIcon(nav.icon)" size="3x" 
          [ngClass]="{
                       'social-container': true,
                       'selected-item-container horizon-menu-item__collapsed-image': this.currentRoute != '' && this.currentRoute.startsWith(nav.url),
                       'other-item-container  horizon-menu-item__collapsed-image': !(this.currentRoute != '' && this.currentRoute.startsWith(nav.url))}"
                       
                       [ngStyle]="{'color': nav.iconColor}">
        </fa-icon>


    </li>
  </div>
      

      <!-- <li 
       class="dropdown-icon" 
       nz-submenu nzMode="inline" 
       style="padding-bottom: 9px; padding-top: 4px;"
       *ngIf="nav.labelTranslationId === 'Layout.Sider.Configure' && !userContext.isInspektorRAS() && isCollapsed">
       <span style="margin-left: -9px;" title="">
         <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
        </span>
        <ul nz-menu [nzMode]="'vertical'">
          <li 
           nz-menu-item 
           (click)="onNavigation('configure-algorithm')" 
           style="padding-left: 20px !important; color: #9fa3aa; height: 50px !important;" >
            <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
            <span>{{ getTranslation('Layout.Sider.ConfigureAlg') }}</span>
          </li>
          <li 
            nz-menu-item 
            (click)="onNavigation('configure-training')" 
            style="padding-left: 20px !important; color: #9fa3aa; height: 50px !important;" >
            <img [src]="nav.iconUrl" height="40" width="40" style="margin-right: 7px">
             <span>{{ getTranslation('Layout.Sider.Configure') }}</span>
          </li>
        </ul>
      </li>-->
    </ng-container>
  </ul>
</ng-container>

<nz-divider class="horizon-divider"></nz-divider>

<!--
<div style="cursor:pointer ; display:flex ; margin-bottom:20px ;" [style.margin-left]="isCollapsed ? '40%' : '60%'" (click)="logout()">
  <img  src="./../../../../../public/images/logoutt.svg" height="35" width="40" />

  <span *ngIf="!isCollapsed" class="logout-text"> Logout</span>
</div>-->



